export const MC0653_TREATMENT_KEY = 'mc-0653';
export const MC0653_GROUP_PARAMETER = 'group';
export const MC0653_GROUP_CONTROL = 'control';
export const MC0653_GROUP_VARIATION = 'variation';